export default {
  user: null,
  user2: null, // set temporary user object upon setting up 2FA purpose only
  isFoodicsPay: false,
  userRole: [],
  isUserAllowed: false,
  concept: {},
  language: {},
  integration: {},
  conceptSettings: null,
  subscription: null,
  applications: {},
  dashboard: 5,
  merchentId: null,
  paymentId: null,
  client: null,
};
